<template>
    <div class="body">
        <div class="box">
            <div class="back" @click="$router.go(-1)">
                <img src="../../assets/img/i19.png" />
                返回
            </div>
            <div class="center">
                <div class="c_left">{{ info.name }}</div>

                <div class="c_right">
                    <div class="cr_btn crb" @click="btn_classDissolve" v-if="bzrFlag">解散教研组</div>
                    <!-- <div class="cr_btn crb" @click="downLoadTemplate">邀请老师</div> -->
                    <div class="cr_btn crb" @click="downLoadTemplate">下载教师信息模板</div>
                    <el-upload :headers="myHeaders" :http-request="handleUploadForm" :on-change="imgSaveToUrl"
                        :show-file-list="false" action class="upload-demo" multiple accept=".xlsx">
                        <div class="cr_btn crb">导入教师</div>
                    </el-upload>
                    <!-- <el-upload :headers="myHeaders" :http-request="handleUploadForm1" :on-change="imgSaveToUrl"
                        :show-file-list="false" action class="upload-demo" multiple accept=".zip">
                        <div class="cr_btn crb">导入教师头像</div>
                    </el-upload> -->
                    <!-- <div class="cr_btn crb" @click="createClassFlag = true">新建班级</div> -->
                    <!-- <div class="cr_btn" @click="addClassFlag = true">加入班级</div> -->
                    <!-- <div class="cr_btn" @click="$router.push('/home/classShow')">班级显示</div> -->
                </div>
            </div>
            <div class="bottom">
                <div class="item" v-for="(item, index) in studentList" :key="index" v-if="index > 0"
                    @click="btn_stu(item, index)">
                    <img class="i_top"
                        :src="webImg + item.avatar + '?x-oss-process=image/resize,m_fixed,w_100,h_100'" />
                    <div class="i_bottom">{{ item.name }}</div>
                </div>
                <div class="item" @click="stuInfo = {},editFlag=false,studentPop = true">
                    <img class="i_top" src="../../assets/img/i30.png" />
                    <div class="i_bottom">添加教师</div>
                </div>
            </div>

        </div>
        <div class="popup" v-if="studentPop">
            <div class="p_box">
                <div class="pb_top">
                    <div>编辑教师信息</div>
                    <img src="@/assets/img/close.png" @click="studentPop = false" />
                </div>
                <div class="pb_center">
                    <div class="pbc_item">
                        <div class="bci_left">头像：</div>
                        <div class="bci_right">
                            <el-upload :headers="myHeaders" :http-request="handleUploadImgForm"
                                :on-change="imgSaveToUrl" :show-file-list="false" action class="upload-demo" multiple
                                accept="image/*">
                                <div class="cir_img_add" v-if="!stuInfo.avatar">
                                    <img src="@/assets/img/i29.png" />
                                    上传
                                </div>
                                <img class="tx" :src="webImg + stuInfo.avatar" v-if="stuInfo.avatar" />
                            </el-upload>
                        </div>
                    </div>
                    <div class="pbc_item">
                        <div class="bci_left"><span>*</span>姓名：</div>
                        <div class="bci_right">
                            <el-input class="cir_input" v-model="stuInfo.name" placeholder="请输入..."></el-input>
                        </div>
                    </div>
                    <div class="pbc_item">
                        <div class="bci_left"><span>*</span>账号：</div>
                        <div class="bci_right">
                            <el-input class="cir_input" type="number" v-model="stuInfo.stdNo"
                                placeholder="请输入..."></el-input>
                        </div>
                    </div>
                </div>
                <div class="pb_bottom">
                    <el-button type="danger" @click="btn_delStu" v-if="editFlag">删除</el-button>
                    <el-button @click="studentPop = false" v-else>取消</el-button>
                    <el-button type="primary" @click="studentAdd">保存</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    classInfo,
    checkPermi,
    classStudentList,
    classStudentAdd,
    ossToken,
    importStudentData,
    importTemplate,
    studentInfo,
    studentUpdate,
    importStudentAvatarData,
    verifyTableFormat,
    studentRemove,
    classDissolve,
    addForJY,
    importTemplateJY,
    verifyTableFormatForJY
} from '@/apis/index'
import axios from 'axios'

export default {
    data() {
        return {
            studentPop: false,
            classId: this.$route.query.id,
            info: {},
            techSectionId: '',
            bzrFlag: '',
            studentList: [],
            stuInfo: {
                classId: '',
                avatar: null,
                name: '',
                stdNo: '',
            },
            myHeaders: { "X-Token": ossToken() },
            editFlag: false
        }
    },
    created() {

    },
    mounted() {
        if (this.classId) {
            this.getCheckPermi()
            this.getClassInfo()
            this.getClassStudentList()
        }
    },
    methods: {
        downLoadTemplate() {
            // axios.get('tech/class/student/importTemplateJY', {
            //     responseType: 'blob'  // 关键，告诉axios以二进制流接收
            // }).then(response => {
            //     const blob = response.data;

            //     // 创建下载链接
            //     const url = window.URL.createObjectURL(blob);
            //     const a = document.createElement('a');
            //     a.href = url;
            //     a.download = 'file.zip';  // 你想保存的文件名
            //     document.body.appendChild(a);
            //     a.click();

            //     // 释放URL对象
            //     window.URL.revokeObjectURL(url);
            //     a.remove();
            // }).catch(error => {
            //     console.error('下载失败', error);
            // });
            window.open('https://qimiyun.oss-cn-hangzhou.aliyuncs.com/pc/%E8%B4%A6%E5%8F%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx')
        },
        btn_classDissolve() {
            this.$confirm('是否确认解散该教研组?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                classDissolve(this.classId).then(res => {
                    console.log(res, 'studentRemove');
                    this.$message.success('解散成功')
                    setTimeout(() => {
                        this.$router.go(-1)
                    }, 500);
                })
            })
        },
        btn_delStu() {
            this.$confirm('是否确认删除该教师?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                studentRemove({
                    id: this.classId,
                    studentIds: this.stuInfo.id
                }).then(res => {
                    console.log(res, 'studentRemove');
                    this.studentPop = false
                    this.$message.success('删除成功')
                    this.getClassStudentList()
                })
            })
        },
        // downLoadTemplate() {
        //     window.open('https://qimiyun.oss-cn-hangzhou.aliyuncs.com/pc/%E5%AD%A6%E7%94%9F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx')
        // },
        btn_stu(item, index) {
            this.stuInfo = {}
            studentInfo(item.studentId).then(res => {
                console.log(res, 'studentInfo');
                this.stuInfo = res.data
                this.studentPop = true
                this.editFlag = true
            })
        },
        studentAdd() {
            this.stuInfo.classId = this.classId
            // if (!this.stuInfo.avatar) {
            //     return this.$message.error('请上传学生头像')
            // }
            if (!this.stuInfo.name) {
                return this.$message.error('请输入姓名')
            }
            if (!this.stuInfo.stdNo) {
                return this.$message.error('请输入账号')
            }
            if (this.editFlag) {
                studentUpdate(this.stuInfo).then(res => {
                    this.studentPop = false
                    this.editFlag = false
                    this.$message.success('修改成功')
                    this.getClassStudentList()
                })
            } else {
                addForJY(this.stuInfo).then(res => {
                    console.log(res, 'addForJY');
                    this.studentPop = false
                    this.$message.success('添加成功')
                    this.getClassStudentList()
                })
            }
        },
        handleUploadForm1(param) {
            const formData = new FormData();
            formData.append("multipart", param.file);
            let loading = this.$loading({
                lock: true,
                text: "上传中，请稍候...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            // 获取上传token
            ossToken(param.file.name).then(res => {
                let ossRes = JSON.parse(res.data);
                console.log(ossRes, 'getOssToken')
                const ossData = new FormData();
                Object.keys(ossRes).forEach((key) => {
                    ossData.append(key, ossRes[key]);
                });

                console.log(param.file, 'param.file')
                ossData.append("file", param.file);
                var url = ossRes.host;
                axios({
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    method: 'post',
                    url: url,
                    data: ossData
                }).then(async (res2) => {
                    console.log(res2, 'getOssToken axios')
                    loading.close();
                    importStudentAvatarData({
                        file: res2.data.url,
                        updateSupport: true,
                        classId: this.classId
                    }).then(res3 => {
                        console.log(res3, 'res3');
                        this.studentPop = false
                        this.$message.success('导入成功')
                        this.getClassStudentList()
                    })
                })
            })
        },
        handleUploadForm(param) {
            const formData = new FormData();
            formData.append("multipart", param.file);
            let loading = this.$loading({
                lock: true,
                text: "上传中，请稍候...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            // 获取上传token
            ossToken(param.file.name).then(res => {
                let ossRes = JSON.parse(res.data);
                console.log(ossRes, 'getOssToken')
                const ossData = new FormData();
                Object.keys(ossRes).forEach((key) => {
                    ossData.append(key, ossRes[key]);
                });

                console.log(param.file, 'param.file')
                ossData.append("file", param.file);
                var url = ossRes.host;
                axios({
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    method: 'post',
                    url: url,
                    data: ossData
                }).then(async (res2) => {
                    console.log(res2, 'getOssToken axios')
                    loading.close();
                    verifyTableFormatForJY({
                        file: res2.data.url,
                        classId: this.classId,
                        updateSupport: true
                    }).then(res3 => {
                        importStudentData({
                            file: res2.data.url,
                            classId: this.classId,
                            updateSupport: true
                        }).then(res => {
                            this.studentPop = false
                            this.$message.success('导入成功')
                            this.getClassStudentList()
                        })
                    }).catch(err => {
                        this.studentPop = false
                        this.$message.error(err.msg)
                    })
                })
            })
        },
        handleUploadImgForm1(param) {
            console.log(param, 'imgup');
            const formData = new FormData();
            formData.append("multipart", param.file);
            let loading = this.$loading({
                lock: true,
                text: "上传中，请稍候...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            // 获取上传token
            ossToken(param.file.name).then(res => {
                let ossRes = JSON.parse(res.data);
                console.log(ossRes, 'getOssToken')
                const ossData = new FormData();
                Object.keys(ossRes).forEach((key) => {
                    ossData.append(key, ossRes[key]);
                });
                console.log(param.file, 'param.file')
                ossData.append("file", param.file);
                var url = ossRes.host;
                axios({
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    method: 'post',
                    url: url,
                    data: ossData
                }).then(async (res2) => {
                    console.log(res2, 'getOssToken axios')
                    this.stuInfo.picture = res2.data.url
                    loading.close();
                })
            })
        },
        handleUploadImgForm(param) {
            console.log(param, 'imgup');
            const formData = new FormData();
            formData.append("multipart", param.file);
            let loading = this.$loading({
                lock: true,
                text: "上传中，请稍候...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            // 获取上传token
            ossToken(param.file.name).then(res => {
                let ossRes = JSON.parse(res.data);
                console.log(ossRes, 'getOssToken')
                const ossData = new FormData();
                Object.keys(ossRes).forEach((key) => {
                    ossData.append(key, ossRes[key]);
                });
                console.log(param.file, 'param.file')
                ossData.append("file", param.file);
                var url = ossRes.host;
                axios({
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    method: 'post',
                    url: url,
                    data: ossData
                }).then(res2 => {
                    console.log(res2, 'getOssToken axios')
                    this.stuInfo.avatar = res2.data.url
                    console.log(this.stuInfo.avatar, 'this.stuInfo.avatar');
                    this.$forceUpdate()
                    loading.close();
                })
            })
        },
        // 选取图片后自动回调，里面可以获取到文件
        imgSaveToUrl(event) {
            console.log(event, 'eventOnchange');
        },
        getClassStudentList() {
            classStudentList(this.classId).then(res => {
                res.data.forEach(e => {
                    if (e.studentId != 0) {
                        e.select = 0
                    } else {
                        e.name = '全班'
                    }
                })
                this.studentList = res.data
                console.log(res, 'classStudentList');
            })
        },
        getCheckPermi() {
            checkPermi(this.classId).then(res => {
                console.log(res, 'checkPermi');
                this.bzrFlag = res.data
            })
        },
        getClassInfo() {
            classInfo(this.classId).then(res => {
                console.log(res, 'classInfo');
                this.info = res.data
                this.techSectionId = res.data.techSectionId
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.body {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .popup {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 99;
        background-color: rgba(0, 0, 0, 0.4);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .p_box {
            width: 972px;
            height: 594px;
            background: #FFFFFF;
            border-radius: 10px 10px 10px 10px;
            position: relative;

            .pb_top {
                width: 100%;
                height: 42px;
                background: #D9EBFF;
                border-radius: 10px 10px 0px 0px;
                box-sizing: border-box;
                padding: 0 20px;
                display: flex;
                align-items: center;

                justify-content: space-between;

                div {
                    font-weight: bold;
                    font-size: 18px;
                    color: #000000;
                }

                img {
                    width: 20px;
                    height: 20px;
                    cursor: pointer;
                }
            }

            .pb_center {
                width: 100%;

                .pbc_item {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    box-sizing: border-box;
                    padding: 0 200px 0 30px;
                    margin-top: 30px;

                    .bci_left {
                        width: 130px;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                        text-align: right;

                        span {
                            color: red;
                        }
                    }

                    .bci_right {
                        flex: 1;
                        margin-left: 10px;

                        .tx {
                            width: 100px;
                            height: 100px;
                        }

                        .cir_img_add {
                            width: 100px;
                            height: 100px;
                            background: #F2F2F2;
                            border-radius: 50px 50px 50px 50px;
                            font-weight: 500;
                            font-size: 16px;
                            color: #333333;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            cursor: pointer;

                            img {
                                width: 32px;
                                height: 32px;
                                margin-bottom: 13px;
                            }
                        }

                        .cir_input {
                            width: 100%;
                            height: 32px;
                        }
                    }
                }
            }

            .pb_bottom {
                width: 100%;
                height: 80px;
                border-top: 1px solid#F0F0F0;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                left: 0;
                bottom: 0;

                .el-button {
                    width: 120px;
                }

                .pbb_btn {
                    width: 120px;
                    height: 40px;
                    background: #FFFFFF;
                    border-radius: 8px;
                    border: 1px solid #333333;
                    font-weight: bold;
                    font-size: 16px;
                    color: #333333;
                    text-align: center;
                    line-height: 40px;
                    cursor: pointer;
                }

                .pbb_btn1 {
                    width: 120px;
                    height: 40px;
                    background: #5AA7F7;
                    box-shadow: 0px 6px 15px 0px rgba(29, 151, 239, 0.21);
                    border-radius: 8px;
                    font-weight: bold;
                    font-size: 16px;
                    color: #FFFFFF;
                    text-align: center;
                    line-height: 40px;
                    margin-left: 15px;
                    cursor: pointer;
                }
            }
        }
    }

}

.box {
    width: 1200px;
    height: 100%;
    position: relative;
    height: 0;
    flex: 1;
    display: flex;
    flex-direction: column;

    .back {
        width: 100%;
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 14px;
        color: #000000;
        // margin-bottom: 10px;
        margin-top: 10px;
        cursor: pointer;
        box-sizing: border-box;

        img {
            width: 14px;
            height: 14px;

        }
    }


    // box-sizing: border-box;
    // padding: 30px;
    .top {
        width: 100%;
        height: 50px;
        //   background: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 10px;
        z-index: 1;
        left: 70px;
        top: 56px;
        -webkit-app-region: no-drag;


        .t_left {
            display: flex;
            align-items: center;
            font-weight: 500;
            font-size: 12px;
            color: #A6B0BA;
            cursor: pointer;

            img {
                width: 15px;
                height: 15px;
            }
        }

        .t_center {
            font-weight: bold;
            font-size: 16px;
            color: #333333;
        }

        .t_right {
            width: 22px;
            height: 22px;
            cursor: pointer;
        }
    }

    .center {
        width: 100%;
        box-sizing: border-box;
        padding: 20px 0;
        padding-top: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .c_left {
            font-weight: bold;
            font-size: 20px;
            color: #000000;
        }

        .c_right {
            display: flex;
            align-items: center;

            .cr_btn {
                width: fit-content;
                height: 36px;
                background: #FFFFFF;
                border-radius: 8px;
                font-weight: 800;
                font-size: 16px;
                color: #399AFF;
                text-align: center;
                line-height: 36px;
                margin-left: 20px;
                padding: 0 10px;
                cursor: pointer;
            }

            .crb {
                color: #fff !important;
                background: #399AFF !important;
            }
        }
    }

    .bottom::-webkit-scrollbar {
        display: none;
    }

    .bottom {
        width: 100%;
        height: 0;
        flex: 1;
        // border: 1px solid #fff;
        box-sizing: border-box;
        padding: 20px 0;
        display: flex;
        align-items: center;
        align-content: flex-start;
        flex-wrap: wrap;
        overflow-y: scroll;
        margin-bottom: 20px;

        .item:nth-child(3n) {
            // margin-right: 0 !important;
        }

        .item {
            width: 10%;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 20px;
            cursor: pointer;

            .i_top {
                width: 83px;
                height: 83px;
                border-radius: 6px;
            }

            .i_bottom {
                width: 100%;
                text-align: center;
                font-weight: 500;
                font-size: 16px;
                color: #333333;
                margin-top: 10px;
            }
        }
    }
}
</style>
